//scss:
require("index/Index.scss");

//import registerServiceWorker from 'core/registerServiceWorker';

//BASE
let _app = require("base/Application");

//ENUM:
const ENUM = require("core/Enum");

//UTILS:
const Loader = require("util/Loader");
const Firebase = require("util/FireBase");

_app.init = function(){
    _app.addedFlag = false;
    _app.removedFlag = false;

    //registerServiceWorker();
    //check Browser support:

    if(_app.supported()) {
        Loader.script("/vendor/jquery-3.2.1.slim.min.js", "$", function(){
            if(Firebase.initialized){
                _app.appReady();
            }
        });
        Firebase.invoke(function(){
            if(typeof jQuery != 'undefined'){
                _app.appReady();
            }
        });
    }
};

_app.appReady = function(){
    _app.router = require("core/Router");
    _app.router.initialize();
    _app.router.addPathWatcher(_app.pathChanged);
    //ADS:
    (adsbygoogle = window.adsbygoogle || []);
};

_app.supported = function(){
    let supported = true;
    //if (typeof(Worker) === "undefined")
     //   supported = false;
    if(!window.history || !history.pushState)
        supported = false;
    return supported;
};

_app.pathChanged = function(l1, l2, l3){
    let isApp = (l1 === ENUM.VIEWS.APP || l1 === ENUM.VIEWS.IN);
    if(isApp && !_app.addedFlag){
        $(".indexed").addClass("app-state");
        _app.addedFlag = true;
        _app.removedFlag = false;
    }
    else if(!isApp && !_app.removedFlag){
        $(".indexed").removeClass("app-state");
        _app.addedFlag = false;
        _app.removedFlag = true;
    }
};

_app.init();

//guest@ieo.com
//test123



// WEBPACK FOOTER //
// ./src/index/Index.js